/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteTapsPrescription$Params {
  'X-Auth-Token': string;
  tenantDiscr: number;
  instanceDiscr: number;
  prescriptionNumber: string;
  treatmentId: string;
}

export function deleteTapsPrescription(http: HttpClient, rootUrl: string, params: DeleteTapsPrescription$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteTapsPrescription.PATH, 'delete');
  if (params) {
    rb.header('X-Auth-Token', params['X-Auth-Token'], {});
    rb.header('tenantDiscr', params.tenantDiscr, {});
    rb.header('instanceDiscr', params.instanceDiscr, {});
    rb.path('prescriptionNumber', params.prescriptionNumber, {});
    rb.query('treatmentId', params.treatmentId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteTapsPrescription.PATH = '/api/internal/prescriptions/{prescriptionNumber}';
